/**
 * @file index.tsx
 *
 * @fileoverview Renders button for sending e-mail.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import EnvelopeIcon from '~/vcl/icons/Envelope';
import { FormattedMessage } from 'react-intl';

export default function EmailSharingButton({
  title,
  url,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_email"
          defaultMessage="via Email"
        />
      }
      urlToShare={url}
      href={`mailto:?subject=${encodeURIComponent(title || '')}&body=`}
      IconComponent={EnvelopeIcon}
      {...props}
    />
  );
}
export { EmailSharingButton };
